<template>
  <div>
    <v-row justify="center" align="center">
      <v-col cols="12" md="8" lg="6">
        <v-alert
            variant="outlined"
            color="info"
            icon="mdi-information"
            border="start"
        >
          <div>
            <strong>
              {{ $t('menus.subscriptions.subscribeWebpage') }}:
            </strong>
            <a href="https://portal.tubeway.io/console/subscriptions" target="_blank">https://portal.tubeway.io/console/subscriptions</a>
          </div>
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore'
import { useTenantStore } from '@/stores/TenantStore.js'

export default {
  name: "SubscriptionsLink",
  afterCreate() {
    if (!this.$canControlTenantConfig()) {
      this.$router.push('/console/index');
    }

    if (this.isRecurringSubscription(this.subscriptionType)) {
      this.$router.push('/console/index');
    }
  },
  watch: {
    subscriptionType(newType) {
      if (this.isRecurringSubscription(newType)) {
        this.$router.push('/console/index');
      }
    }
  },
  methods: {
    isRecurringSubscription(type) {
      const tenantStore = useTenantStore();
      return tenantStore.getRecurringSubscriptionTypes.includes(type);
    }
  },
  computed: {
    subscriptionType: function() {
      const authStore = useAuthStore();
      const activeTenant = authStore.getActiveTenant;

      if (activeTenant?.subscription?.subscriptionType) {
        return activeTenant.subscription.subscriptionType;
      }

      return null;
    },
  },
}
</script>

<style>
</style>
